// eslint-disable-next-line import/prefer-default-export
export const CIRCULAR_PROGRESS = {
  margin: 'auto',
};

export const minInputWidth = '300px';
